<div class="NgxEditor__Seperator ng-star-inserted"></div>
<div class="NgxEditor__MenuItem NgxEditor__MenuItem--Text"
     [ngClass]="{'NgxEditor__MenuItem--Active': isActive, 'NgxEditor--Disabled': isDisabled}">
  <button mat-icon-button class="add_image_button" (mousedown)="onClickAddImage($event)">
    <mat-icon>image</mat-icon>
  </button>
</div>

